// Browser error reporting (plan decision 13). The server says whether Sentry is on and with which
// DSN (/api/client-config, public; empty locally), and the SDK is only downloaded when it is.
// Errors only: no tracing, replay or session pings (BrowserSession would report every page view,
// which the Privacy page rules out). Sentry v11 collects user info (including the IP address),
// cookies and headers by default, so those are switched off here, except User-Agent, which says
// which browser failed; the Privacy page says what is sent.
export function startErrorReporting() {
  fetch('/api/client-config')
    .then((res) => (res.ok ? res.json() : {}))
    .then(async (config) => {
      if (!config.sentry_dsn) return
      const Sentry = await import('@sentry/react')
      Sentry.init({
        dsn: config.sentry_dsn,
        release: config.sentry_release,
        environment: config.sentry_environment,
        dataCollection: {
          userInfo: false,
          cookies: false,
          httpHeaders: { request: { allow: ['User-Agent'] }, response: false },
          httpBodies: [],
        },
        integrations: (defaults) => defaults.filter((i) => i.name !== 'BrowserSession'),
        // A public walk link's token opens the walk, so it's taken out of everything sent.
        beforeSend: scrubShareTokens,
        beforeSendTransaction: scrubShareTokens,
        beforeBreadcrumb: scrubShareTokens,
        initialScope: { tags: { side: 'browser' } },
      })
    })
    .catch(() => {})
}

const SHARE_TOKEN = /(\/api\/share\/|\/s\/)[A-Za-z0-9_-]+/g
function scrubShareTokens(item) {
  return item && JSON.parse(JSON.stringify(item).replace(SHARE_TOKEN, '$1<token>'))
}
